<template>
    <div>
        <div class="container">
            <div class="handle-box">
                <el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-add"
                    @click="handleEdit(true, null)"
                >新增</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                v-loading="loading"
            >
                <el-table-column label="序号" align="center" width="50">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="供应商" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
                <el-table-column prop="discount" label="折扣" align="center"></el-table-column>
                <el-table-column label="创建日期" align="center">
                    <template slot-scope="scope">
                        {{formatDate(scope.row.created_time)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="handleEdit(false, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="totalPages > 1">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="currentPage"
                    :page-size="page_size"
                    :page-count="totalPages"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="editVisible" width="60%" :close-on-click-modal="false">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px">
                <el-form-item label="供应商：" prop="name">
                    <el-input
                     v-model="form.name" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="phone">
                    <el-input
                     type="number"
                     v-model="form.phone" @input="onInput()"></el-input>
                </el-form-item>
                <el-form-item label="折扣：" prop="discount">
                    <el-input
                     type="number"
                     v-model="form.discount" @input="onInput()"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer self-dialog-footer">
                <el-button type="primary" @click="saveEdit('ruleForm')">提 交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import echarts from "echarts";
import {_} from 'vue-underscore';
const { export_json_to_excel } = require("../../../utils/Export2Excel.js");
import http from '../../../api/pontusApiConfig'
export default {
    name: 'prescriptionlist',
    data() {
      let checkPhone = (rule, value, callback) => {
      let reg = /^1\d{10}$/
      if (!reg.test(value)) {
        callback(new Error('请输入11位手机号'))
      } else {
        callback()
      }
    }
    return {
            tableData: [],
            currentPage: 1,
            totalPages: 1,
            page_size: 10,
            pageTotal: 10,
            loading: false,
            is_add: false,
            editVisible: false,
            form: {},
            rules: {
                name: [{ required: true, message: "请填写供应商", trigger: "blur" }],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { type: 'number', validator: checkPhone, message: '请输入11位有效手机号号码', trigger: ['blur', 'change'] }
                ],
                discount: [{ required: true, message: "请填写折扣", trigger: "blur" }]
            }
        };
    },
    created() {
        this.getData();
    },
    methods: {
        formatDate(time){
            return new Date(time*1000).Format('YYYY-MM-DD hh:mm:ss');
        },
        getData() {
            let that = this;
            that.loading = true;
            let params = {
                page: that.currentPage,
                page_size: that.page_size
            }
            http.get("/admin/coupon/channels", {params: params}).then(function(res) {
                that.tableData = res.data.data.channels;
                that.currentPage = parseInt(res.data.data.current_page);
                that.totalPages = res.data.data.total_pages;
                that.loading = false;
            });
        },
        onInput(){
            this.$forceUpdate();
        },
        // 分页导航
        handlePageChange(val) {
            this.currentPage = val;
            this.getData();
        },
        handleDelete(row) {
            let that = this;
            // 二次确认删除
            that.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
            .then(() => {
                let params = {
                    channel_id: row.channel_id
                }
                http.delete("/admin/coupon/channels", {params: params}).then(function(res) {
                    if (res.data.status_code == 200) {
                        that.$message.success('删除成功');
                        that.getData();
                    }
                });
            })
            .catch(() => {});
        },
        handleEdit(add, row){
            if(add){
                this.form = {}
            }else{
                this.form = {
                    channel_id: row.channel_id,
                    name: row.name,
                    phone: row.phone,
                    discount: row.discount
                }
            }
            this.is_add = add;
            this.editVisible = true;
        },
        saveEdit(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        name: that.form.name,
                        phone: that.form.phone,
                        discount: that.form.discount
                    }
                    if(that.is_add){
                        http.post("/admin/coupon/channels", params).then(function(res) {
                        if (res.data.status_code == 200) {
                            that.currentPage = 1;
                            that.getData();
                        }else{
                            that.$error.success(res.data.msg);
                        }
                    });
                    }else{
                        params['channel_id'] = that.form.channel_id;
                        http.put("/admin/coupon/channels", params).then(function(res) {
                        if (res.data.status_code == 200) {
                            that.currentPage = 1;
                            that.getData();
                        }else{
                            that.$error.success(res.data.msg);
                        }
                    });
                    }
                    that.editVisible = false;
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="scss" type="text/css" scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 180px;
}
.self-dialog-footer{
    display: block;
    text-align: center;
}
.avatar {
    height: 178px;
    display: block;
    max-width: 100%;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.clearfix:after{content:"";display:block;height:0;clear:both;visibility:hidden;}
.fl{float:left;display:inline;}
.fr{float:right;display:inline;}
.medicines-ul{
    margin-top: 5px;
}
.medicines-ul .li,
.select-medicines-ul li{
    list-style-type: none;
}
.medicines-li{
    margin-right: 5px;
    margin-bottom: 5px;
    display: block;
    max-width: 100%;
    height: 30px;
    line-height: 20px;
    box-sizing: border-box;
    color: #333;
    text-align: center;
    font-size: 14px;
    padding: 5px;
    border: 1px solid #eee;
    border-radius: 6px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
}
.select-medicines-ul{
    width: 100%;
    min-height: 200px;
}
.select-medicines-li{
    margin-top: 10px;
    width: 33.333333%;
    box-sizing: border-box;
    padding-left: 25px;
    padding-right: 100px;
    position: relative;
}
.delete-medicine{
    width: 20px;
    height: 20px;
    padding: 3px;
    margin: auto;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
}
.medicine-name{
    display: block;
    width: 100%;
    height: 32px;
    line-height: 32px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.medicine-input{
    width: 50px;
    height: 32px;
    line-height: 32px;
    display: block;
    text-align: center;
    position: absolute;
    right: 50px;
    top: 0;
}
.medicine-input .el-input__inner{
    text-align: center;
}
.medicine-unit{
    display: block;
    height: 32px;
    line-height: 32px;
    position: absolute;
    right: 30px;
    top: 0;
}
</style>
